import React from 'react'
import { BgImg, ChooseTokenToWithdraw, ContainerWidth, TokenWithdrawGamefiHeadingCenter } from './WithdrawStyled';
import WithdrawHeader from 'components/Header/WithdrawHeader';
import { Box } from 'components/Box'
import { UserProfileImage, UserProfile, EditImageStyle, UserPayment, UserProfileDetails, UserCash, UserName } from './WithdrawStyled'
import { useState } from 'react';
import { ReactComponent as Binance } from "assets/Currency/BinanceLogo.svg";
import { ReactComponent as BUSD } from "assets/Currency/BUSDLogo.svg";
import { ReactComponent as BitCoin } from "assets/Currency/BitcoinBTCLogo.svg";
import { ReactComponent as Ethereum } from "assets/Currency/EthereumLogo.svg";
import { ReactComponent as Ripple } from "assets/Currency/RippleLogo.svg";
import './styles.css';
import { Text } from 'components/Text';
import { Link } from "react-router-dom"
import { ReactComponent as EditIcon } from 'assets/Icons/CheckBox/EditIcon.svg';
import { DiamondStyle, DiamondStyleChecked, WorkingBoxStyle, WorkingTextStyle } from 'views/Landing/Components/HowItWorks/HowItWorksStyled';
import { Cross2Icon } from '@radix-ui/react-icons';
import { IconButtonStyle } from 'views/Forms/ModalStyled';

const TokenWithdraw: React.FC = () => {

    const isChecked = (e, crypto) => {
        setValue(crypto.title);
        setValueId(crypto.id);
    };

    const [value, setValue] = useState("ABC");
    const [valueId, setValueId] = useState(0);
    const [cryptos, setCryptos] = useState(
        [
            {
                id: 1,
                Icon: Binance,
                title: "Binance",
                // checked: false,
            },
            {
                id: 2,
                Icon: BUSD,
                title: "Binance USD",
                // checked: true,
            },
            {
                id: 3,
                Icon: BitCoin,
                title: "Bitcoin",
                // checked: false,
            },
            {
                id: 4,
                Icon: Ethereum,
                title: "Ethereum",
                // checked: false,
            },
            {
                id: 5,
                Icon: Ripple,
                title: "Ripple",
                // checked: false,
            },
        ],
    );

    return (
        <>
            <BgImg>
                <WithdrawHeader />
                <ContainerWidth>

                    <UserProfile>
                        <UserProfileImage>
                            <Text>AZ</Text>
                        </UserProfileImage>

                        <UserProfileDetails>
                            <UserName>Aleena Zaheer</UserName>
                            <UserCash>500 BTC</UserCash>

                            <EditImageStyle>
                                <UserPayment>{value}</UserPayment>
                                <Link to='./tokenwithdraw' >
                                    <EditIcon />
                                </Link>
                                <Link to='./withdrawdetail' >
                                    <IconButtonStyle>
                                        <Cross2Icon />
                                    </IconButtonStyle>
                                </Link>
                            </EditImageStyle>

                        </UserProfileDetails>

                    </UserProfile>

                    <ChooseTokenToWithdraw>

                        <TokenWithdrawGamefiHeadingCenter textAlign='center'>
                            Please Choose Token To Withdraw
                        </TokenWithdrawGamefiHeadingCenter>

                        {/* <WorkingBoxStyle>
                            {
                                cryptos.map((crypto, i) => (
                                    <Box key={crypto.id} style={{ marginRight: '40px' }} onClick={(e) => isChecked(e, crypto)} className={valueId == crypto.id && "highlighted"}>

                                        <DiamondStyle>
                                            <crypto.Icon style={{ height: '60px', width: '60px' }} />
                                        </DiamondStyle>

                                        <WorkingTextStyle>{crypto.title}</WorkingTextStyle>
                                    </Box>
                                ))
                            }
                        </WorkingBoxStyle> */}

                        <WorkingBoxStyle>
                            {
                                cryptos.map((crypto, i) => (
                                    <Box key={crypto.id} style={{ marginRight: '40px' }}>
                                        {
                                            (valueId == crypto.id) ?
                                                <DiamondStyleChecked onClick={(e) => isChecked(e, crypto)}>
                                                    <crypto.Icon style={{ height: '60px', width: '60px' }} />
                                                </DiamondStyleChecked>
                                                :
                                                <DiamondStyle onClick={(e) => isChecked(e, crypto)}>
                                                    <crypto.Icon style={{ height: '60px', width: '60px' }} />
                                                </DiamondStyle>
                                        }
                                        <WorkingTextStyle>{crypto.title}</WorkingTextStyle>
                                    </Box>
                                ))
                            }
                        </WorkingBoxStyle>

                    </ChooseTokenToWithdraw>

                </ContainerWidth>
            </BgImg>
        </>
    )
}

export default TokenWithdraw